import { useUpdate } from 'react-admin';
import { useGetAppConfig } from './useGetAppConfig';
import { useOnSettled } from './useOnSettled';
import { useCallback } from 'react';
import {
  Box,
  CircularProgress,
  Switch,
  Tooltip,
  IconButton,
  Typography,
} from '@mui/material';
import { Semaphore } from './Semaphore';
import { useLogEffect } from '@/util/useLogEffect';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const PromptForDetailsIfMissingForApple = () => {
  const [updateConfig, { isLoading: isUpdating }] = useUpdate(
    'therapistAppConfig',
    { id: 'current' },
  );

  const {
    remoteAppConfig: { ff_promptForDetails_ifMissingForApple },
    refetchAppConfig,
  } = useGetAppConfig();

  const { onSettled: doSettled } = useOnSettled();

  const onSettled = useCallback(async () => {
    doSettled();
    await refetchAppConfig();
  }, [doSettled, refetchAppConfig]);

  useLogEffect(
    'ff_promptForDetails_ifMissingForApple',
    ff_promptForDetails_ifMissingForApple,
  );

  const onSwitch = useCallback(async () => {
    await updateConfig(
      'therapistAppConfig',
      {
        id: 'current',
        data: {
          ff_promptForDetails_ifMissingForApple:
            ff_promptForDetails_ifMissingForApple ? 0 : 1,
        },
      },
      {
        onSettled,
      },
    );
  }, [
    updateConfig,
    onSettled,
    ff_promptForDetails_ifMissingForApple,
  ]);

  return (
    <Box marginTop="2rem">
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">
          Prompt for Name/Email if missing for Apple
        </Typography>
        <Tooltip title="Forces Apple SSO users to provide their name and email if these details are missing from their profile. This flag should be disabled during Apple App Store review to avoid rejection.">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
      >
        <Switch
          checked={!!ff_promptForDetails_ifMissingForApple}
          onChange={onSwitch}
        />
        <Box
          marginLeft="1rem"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          {isUpdating && <CircularProgress size={14} />}
          {!isUpdating && (
            <Semaphore
              enabled={!!ff_promptForDetails_ifMissingForApple}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
